module.exports = __webpack_public_path__ + "static/media/traffic_green.206049ea.png";